module.exports = __webpack_public_path__ + "static/checkatrade_white-f089dc3e1b70731698b751c1e068f9fe.png";